// extracted by mini-css-extract-plugin
module.exports = {"comp":"JM_comp__BUQED"};